module.exports = __webpack_public_path__ + "img/no-image.c41514e8.svg";